import Vue from "vue";
import Vuex from "vuex";
import article from "./modules/article";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    article
  },
  state: {},
  mutations: {
    UPDATE_DATA(state, { name, data }) {
      state[name] = Object.assign({}, state[name], data);
    }
  },
  actions: {}
});
